import api from './axios'

/**
 * Email API
 */
export const emailApi = {
    /**
     * Send email response
     */
    send: async (submissionId, data) => {
        const response = await api.post('/email/send', {
            submission_id: submissionId,
            ...data,
        })
        return response
    },

    /**
     * Test SMTP connection
     */
    test: async () => {
        const response = await api.post('/email/test')
        return response
    },

    /**
     * Get email templates
     */
    getTemplates: async () => {
        const response = await api.get('/email/templates')
        return response
    },

    /**
     * Save email template
     */
    saveTemplate: async (data) => {
        const response = await api.post('/email/templates', data)
        return response
    },

    /**
     * Send template email
     */
    sendTemplate: async (submissionId, templateId, to) => {
        const response = await api.post('/email/send-template', {
            submission_id: submissionId,
            template_id: templateId,
            to,
        })
        return response
    },

    /**
     * Get email history for submission
     */
    getHistory: async (submissionId) => {
        const response = await api.get(`/email/history/${submissionId}`)
        return response
    },
}

export default emailApi
